<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-2 pb-2 flex items-center">
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div *ngIf="!changeTitleMode" class="font-bold text-md text-secondary uppercase tracking-wider">
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      <button mat-icon-button (click)="openAddOfferModal()" [matTooltip]="'Add Offer'">
        <mat-icon [svgIcon]="'add'" *ngIf="!changeTitleMode"></mat-icon>
      </button>
      <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
        <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
      </button>
      <mat-menu #listCard09Menu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
      </mat-menu>
      <button
        class="cancel-button"
        mat-icon-button
        type="button"
        *ngIf="changeTitleMode"
        [matTooltip]="'Cancel'"
        (click)="toggleEditMode(false)"
      >
        <mat-icon [svgIcon]="'cancel'"></mat-icon>
      </button>

      <!-- Save button -->
      <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon [svgIcon]="'save'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col">
    <table class="w-full bg-transparent" mat-table matSort [dataSource]="unitDataSource" [trackBy]="trackByFn">
      <!-- Date -->
      <ng-container matColumnDef="name">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Unit </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.name }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="interior_sq_ft">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Int Sqft </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.interior_sq_ft }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="site_sq_ft">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Site Sqft </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.site_sq_ft }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="annual_rent">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Rent </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.annual_rent }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lease_start_date">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Lease Start </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.lease_start_date | date: 'MMM dd, y' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lease_end_date">
        <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
          <span class="whitespace-nowrap"> Lease End </span>
        </th>
        <td mat-cell *matCellDef="let unit">
          <span class="pr-6 whitespace-nowrap">
            {{ unit.lease_end_date | date: 'MMM dd, y' }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </div>
</div>
